module.exports = __webpack_public_path__ + "img/logo.357edee7.png";